// extracted by mini-css-extract-plugin
export default {"root":"wWBul__root"};